<template>
  <section class="c_result">
    <h2 class="c_result_ttl">現在のコンテスト状況</h2>
    <h2 class="ranking-title">🏆紹介人数トップ１０🏆</h2>
    <div class="referral-ranking" v-if="!loading">
      <ul class="ranking-list">
        <li
          v-for="item in referralRanking"
          :key="item.rank"
          :class="['ranking-item', { 'top-rank': item.rank <= 3 }]"
        >
          <span class="rank">
            <span v-if="item.rank === 1">1位🥇</span>
            <span v-else-if="item.rank === 2">2位🥈</span>
            <span v-else-if="item.rank === 3">3位🥉</span>
            <span v-else>{{ item.rank }}位</span>
          </span>

          <span class="count">{{ item.count }}人</span>
        </li>
      </ul>
    </div>
    <div v-else>
      <div :class="{ c_load: loading }"></div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      referralRanking: [],
      loading: true
    };
  },
  created() {
    this.$authAxios
      .get("/api/referral-ranking/")
      .then(res => {
        this.referralRanking = res.data;
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped>
.referral-ranking {
  margin: 32px auto 32px;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
  max-width: 420px;
}

.ranking-list {
  list-style: none;
  padding: 0;
}

.ranking-list li {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px dashed #ddd;
}

.ranking-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px dashed #ddd;
  font-size: 16px;
  font-weight: bold;
}

.ranking-item.top-rank {
  font-size: 21px;
  font-weight: bold;
  padding: 12px 0;
}

.ranking-item.top-rank .count {
  color: #ff9800;
}

.ranking-title {
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  color: #78ba00;
  margin-top: 20px;
}
</style>
